import React from 'react';
import Card from 'react-bootstrap/Card';


function CardServicio2() {
    return (
        <Card className='mb-5 mb-md-0' style={{ width: '20rem', height: '32rem' }}>
            <Card.Body className='p-4 d-flex flex-column justify-content-between'>
                <div className="card-icon d-flex flex-column align-items-center mb-2">

                <i class='bx bxs-cart-alt'></i>
                    <h3 className='text-center mt-3'>Ecommerce</h3>
                </div>
                <Card.Text>
                    <i class='bx bx-check'></i> Diseño Responsivo <br />
                    <i class='bx bx-check'></i> Catálogo y carrito de compras <br />
                    <i class='bx bx-check'></i> Pasarela de pago integrada <br />
                    <i class='bx bx-check'></i> Panel de administración <br />
                    <i class='bx bx-check'></i> Integración de Redes Sociales <br />
                    <i class='bx bx-check'></i> Dominio .com.py <br />
                </Card.Text>
                <div className='d-flex justify-content-center '>
                    <a href="https://wa.link/37cf39" className='btn btn-neon mt-2'>Más Info</a>
                </div>
            </Card.Body>
        </Card>
    );
}

export default CardServicio2;
